import { default as Mui5Skeleton } from '@mui/material/Skeleton'
import { CSSProperties, forwardRef } from 'react'
import { default as SkeletonLegacy } from 'react-loading-skeleton'
import { useComponentVersion } from '../hooks'

export enum OsSkeletonVersion {
  V1 = 1, // MUI4 + OS Theme
  V2 = 2, // MUI5 + Stratis
}

export type SkeletonProps = {
  width?: string | number
  height?: string | number
  style?: CSSProperties
  className?: string
  variant?: 'rounded' | 'circular'
  color?: 'default' | 'primary'
}

export const Skeleton = forwardRef<any, SkeletonProps>(({ width, height, ...props }, ref) => {
  const version = useComponentVersion('skeleton')

  // Gets around TS type errors for this rarely used feature
  const refUntyped: any = ref

  width = width ?? '100%'
  height = height ?? '1rem'

  switch (version) {
    case OsSkeletonVersion.V2: {
      const variant = props.variant || 'rounded'
      const style = { ...props.style, display: props.style?.display || 'inline-block' }
      return (
        <Mui5Skeleton
          ref={refUntyped}
          {...props}
          variant={variant}
          animation="wave"
          width={width}
          height={height}
          style={style}
        />
      )
    }
    default:
      return (
        <SkeletonLegacy
          ref={refUntyped}
          {...props}
          circle={props.variant === 'circular'}
          width={width}
          height={height}
        />
      )
  }
})
